export default "__VITE_PUBLIC_ASSET__1c7c5aaa__"